import {AppTourService} from '../../services/app-tour/app-tour.service';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {AppointmentStatusEnum, AppointmentTypeEnum, IAppointment} from '../../models/appointment';
import {UserInfoComponent} from '../user-info/user-info.component';

@Component({
  selector: 'app-modal-show-appointment',
  templateUrl: './modal-show-appointment.component.html',
  styleUrls: ['./modal-show-appointment.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalShowAppointmentComponent implements OnInit {
  @Input() appointment: IAppointment;
  @Input() expertName: string;
  @Input() loadInfoPatient: boolean;
  @Input() isVisibleModal: boolean;
  @Input() isAppointmentCompleted = false;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() rescheduleAppointment: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelAppoitment: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() goToConsultation: EventEmitter<string> = new EventEmitter<string>();
  @Output() goToProfile: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;

  cardConsultationStyles = {};
  appointmentTypeEnum = AppointmentTypeEnum;
  appointmentStatusEnum = AppointmentStatusEnum;

  constructor(
    public appTourService: AppTourService
  ) { }

  /**
   * Inicializa las propiedades necesarias.
   */
  ngOnInit(): void {
    this.cardConsultationStyles = {
      'background-color': '#F6F6FB',
      'box-shadow': 'none'
    };
  }

  /**
   * Al cerrar el modal
   */
  onEmitCloseModal(action?): void {
    this.closeModal.emit(true);
  }

  /**
   * Al hacer clic en reprogramar consulta
   */
  onEmitRescheduleAppointment(): void {
    this.rescheduleAppointment.emit(true);
  }

  /**
   * Al hacer clic en cancelar consulta
   */
  onEmitCancelAppointment(): void {
    this.cancelAppoitment.emit(true);
  }

  /**
   * Emite la acción para redirigir a la vista de consultas para el paciente seleccionado
   */
  onEmitGoToConsultationPage(outOfTime: boolean): void {
    this.goToConsultation.emit(this.appointment.users[0].patientId);
  }

  onEmitGotoProfile(): void {
    this.goToProfile.emit(true);
  }
}
